import _extends from 'babel-runtime/helpers/extends';
var render = function render() {
      var _vm = this,
          _c = _vm._self._c;return _c('div', { staticClass: "category-header" }, [_c('group-legend', { attrs: { "category": _extends({}, _vm.category, {
                        desc: _vm.category.desc || _vm.category.name
                  }), "addValidator": _vm.addValidator, "updateTargetCategory": _vm.updateTargetCategory } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };